import { render, staticRenderFns } from "./PhoneScreen.vue?vue&type=template&id=6a42c290&"
import script from "./PhoneScreen.vue?vue&type=script&lang=js&"
export * from "./PhoneScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports